let armed = false;

export async function armVoiceSession(): Promise<void> {
  armed = true;
}

export async function reassertVoiceSession(): Promise<void> {
  // Browser AudioContext capture is not re-routed by HTMLAudioElement playback
  // the way iOS AVAudioSession can be. Capture constraints live in audioStream.
  armed = true;
}

export async function disarmVoiceSession(): Promise<void> {
  armed = false;
}

export function isVoiceSessionArmed(): boolean {
  return armed;
}
